import { differenceInSeconds, setHours, setMinutes } from 'date-fns';

export function getSecondsToJobStart(date: string, shiftStart: number): number {
  let now = new Date();
  const shiftStartString = shiftStart.toString();
  const shiftMinutes =
    parseInt(
      shiftStartString.slice(
        shiftStartString.length - 2,
        shiftStartString.length,
      ),
      10,
    ) || 0;
  const shiftHours =
    parseInt(shiftStartString.slice(0, shiftStartString.length - 2), 10) || 0;
  const startDate = setHours(
    setMinutes(new Date(date), shiftMinutes),
    shiftHours,
  );
  return differenceInSeconds(startDate, now);
}
